import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify/vuetify'
import i18n from './i18n'
import './registerServiceWorker'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

Vue.use(TiptapVuetifyPlugin, { vuetify })

Vue.config.productionTip = false

export const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
